import React, {FC} from "react";
import {Card, Grid, Typography} from "@material-ui/core";
import {formatDate} from "../../date.utils";
import {SuggestedAvailability} from "../redux/types";
import {SuggestedAvailabilityDialog} from "./SuggestedAvailabilityDialog";
import {SetStepDataType} from "../types";

export const SuggestedAvailabilityPreviewCard: FC<{
    suggestedAvailability: SuggestedAvailability
    servicesIds: string[];
    onConfirm: (s: SetStepDataType) => void;
}> = ({suggestedAvailability, servicesIds, onConfirm}) => {

    const [dialogOpen, setDialogOpen] = React.useState(false);

    return (
        <React.Fragment>
            <SuggestedAvailabilityDialog
                showDialog={dialogOpen}
                toggleDialog={() => setDialogOpen(t => !t)}
                suggestedAvailability={suggestedAvailability}
                servicesIds={servicesIds}
                onConfirm={onConfirm}
            />
            <Grid item xs={12}>
                <Card onClick={() => setDialogOpen(true)} style={{cursor: 'pointer'}}>
                    <div style={{padding: 16}}>
                        <Typography color="secondary">
                            <b>
                                {formatDate(suggestedAvailability.from, "EEEE, dd.MM.yyyy")}
                            </b>
                        </Typography>
                        <Typography variant="body2">
                            <Typography variant="inherit" color="textSecondary">verfügbar</Typography> {formatDate(suggestedAvailability.from, "HH:mm")} - {formatDate(suggestedAvailability.to, "HH:mm")}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" style={{marginTop: 4}}>
                            Helfer: <Typography variant="inherit" color="primary">{suggestedAvailability.workerName}</Typography>
                        </Typography>
                    </div>
                </Card>
            </Grid>
        </React.Fragment>
    )
}
